// ---------------------------------
// ---------------------------------
// ------------ Cookie -------------
// ---------------------------------
// ---------------------------------

// Select the element with the class 'bloc-popin'
var blocPopin = document.querySelector('.bloc-popin');

// Calculate the height of 1% of the viewport height and set it as a CSS variable
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// Update the CSS variable '--blocPopinHeight' on window resize
window.addEventListener('resize', () => {
      var blocPopinHeight = blocPopin.offsetHeight;
      document.documentElement.style.setProperty('--blocPopinHeight', `${blocPopinHeight}px`);
});

// Set the '--blocPopinHeight' CSS variable immediately
setTimeout(function () {
      var blocPopinHeight = blocPopin.offsetHeight;
      document.documentElement.style.setProperty('--blocPopinHeight', `${blocPopinHeight}px`);
}, 0);

// Add the class 'ready' to the blocPopin element after a delay of 600ms
setTimeout(function () {
      blocPopin.classList.add('ready');
}, 600);

// Check if a cookie named "sticky-bar-cookie" exists and hide the element with id 'popin-holder'
if (readCookie("sticky-bar-cookie")) {
      document.getElementById('popin-holder').style.display = 'none';
}

// Function to create a cookie with a given name, value, and expiration days
function createCookie(name, value, days) {
      if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (30 * 60 * 1000)); // 30 minutes expiration time
            var expires = "; expires=" + date.toGMTString();
      }
      else var expires = "";
      document.cookie = name + "=" + value + expires + "; path=/";
      document.getElementById('popin-holder').style.display = 'none';
}

// Function to read the value of a cookie with a given name
function readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
}

// Function to erase a cookie with a given name
function eraseCookie(name) {
      createCookie(name, "", -1);
}

// Function to hide an element with a given id
function hide(obj) {
      var el = document.getElementById(obj);
      el.style.display = 'none';
}